import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-approve-consult',
  templateUrl: './fh-svg-approve-consult.component.html',
  styleUrl: './fh-svg-approve-consult.component.scss'
})
export class FhSvgApproveConsultComponent {
  @Input() color: string = '';
}
